import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import directive from './directive'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/style/theme.scss';
import '@/assets/style/common.scss';
import './permission'
import { download } from '@/api/request'
import VueQuillEditor from 'vue-quill-editor'

// 样式必须引入
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

Vue.use(VueQuillEditor)

Vue.prototype.download = download

import Pagination from "@/components/Pagination";
localStorage.setItem('token', 'dev-token')
Vue.component('Pagination', Pagination)

Vue.use(directive)

Vue.use(ElementUI, {
  size: 'medium' 
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
